const COUNTRY_TIMEZONE = {
  chile: "America/Santiago",
  argentina: "America/Argentina/Buenos_Aires",
  colombia: "America/Bogota",
  mexico: "America/Mexico_City",
  peru: "America/Lima",
};

export function getOperationTimezone(user) {
  const country =
    user?.logisticCompany?.operationsCountry ||
    user?.company?.operationsCountry;
  return (
    COUNTRY_TIMEZONE[country?.toLowerCase()] ||
    Intl.DateTimeFormat().resolvedOptions().timeZone
  );
}
